import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';

export type ChildUser = {
  id: string;
  authId?: string;
  name: string;
  organizationName?: string;
  status: 'Pending' | 'Active';
  createdAt: string;
  email?: string;
};

const useChildUsers = () => {
  const client = supabaseClient;

  const queryFn = async () => {
    return getChildUsers(client);
  };

  return useQuery({
    queryKey: ['child-users'],
    queryFn,
  });
};

export default useChildUsers;

async function getChildUsers(client: SupabaseClient): Promise<ChildUser[]> {
  const { data, error } = await client.functions.invoke('get_child_users', {
    method: 'GET',
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  // Backend returns { data: { childUsers: [...] }, status: 200 }
  // So we need to access data.data.childUsers
  const response = data as any;
  return response?.data?.childUsers || [];
}

